import React from 'react'

import { cn } from '@/lib/utils'
import { Progress } from '@/components/ui/progress'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { getStyles } from '../../utils'
import { VisuallyHidden } from '@/components/ui/visually-hidden'

type AssessmentCardProps = {
  title: string
  total?: number
  passed?: number
  score: number
  description: string
  view?: 'metaData' | 'dataQuality'
}

export function AssessmentCard({
  title,
  total,
  passed,
  score,
  description = '',
  view,
}: AssessmentCardProps) {
  const [openDescriptionModal, setDescriptionModal] = React.useState(false)
  const styles = getStyles(score)
  return (
    <>
      <div
        className={cn(
          'flex h-[144px] min-w-0 flex-1 cursor-pointer flex-col justify-center rounded-lg border border-gray-200 p-2 pl-[16px] pr-[16px] transition-colors hover:bg-gray-50',
        )}
        role='button'
        tabIndex={0}
        {...(description && {
          onClick: () => setDescriptionModal((prevState) => !prevState),
        })}
      >
        <p className={`truncate text-sm font-medium`}>{title}</p>
        <div className='my-5'>
          <p className={`text-lg font-bold ${styles.text}`}>
            {view === 'metaData'
              ? score
                ? parseFloat(score.toFixed())
                : 0
              : view === 'dataQuality'
                ? score
                  ? parseFloat(score.toFixed())
                  : 'NA'
                : parseFloat(score.toFixed())}
            <span className='text-[9px] text-gray-500'>%</span>
          </p>
          <Progress value={score} className='mt-1 h-1.5 bg-opacity-50' color={styles.progress} />
          {view === 'dataQuality' && (
            <p className='my-1 text-xs text-gray-500'>
              {passed ? passed : 'NA'}/{total ? total : 'NA'}
            </p>
          )}
        </div>
      </div>
      {openDescriptionModal && (
        <Dialog
          open={openDescriptionModal}
          onOpenChange={() => setDescriptionModal((prevState) => !prevState)}
        >
          <DialogContent className='flex max-h-[90vh] max-w-xl flex-col'>
            <DialogHeader className='flex-shrink-0 px-1'>
              <VisuallyHidden>
                <DialogTitle>Metric Definition</DialogTitle>
              </VisuallyHidden>
              <VisuallyHidden>
                <DialogDescription>Metric Definition Detail</DialogDescription>
              </VisuallyHidden>
              <h2 className='flex items-center gap-2 text-lg font-bold text-gray-800'>
                {title}{' '}
                <span className={styles.text}>
                  {score ? `${parseFloat(score.toFixed())}%` : 'NA'}
                </span>
              </h2>
            </DialogHeader>
            <p className='mt-1 text-sm font-normal text-gray-800'>{description}</p>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
